module.exports = __webpack_public_path__ + "static/media/white_dot.9cf65c6e.svg";